/** @type {import('./types').FeatureModules} */
export const FEATURE_MODULES = {
  Recruitment: 'Recruitment',
  Onboarding: 'Onboarding',
  Pulse: 'Pulse',
  TimeOff: 'TimeOff',
  Profile: 'Profile',
  Home: 'Home',
  OneOnOne: 'OneOnOne',
  PerformanceReview: 'PerformanceReview',
  Inbox: 'Inbox',
  Calibration: 'Calibration',
  Compliance: 'Compliance',
  CustomerSatisfaction: 'CustomerSatisfaction',
  Organigram: 'Organigram',
  Recognition: 'Recognition',
  News: 'News',
  Development: 'Development',
  Career: 'Career',
  Goals: 'Goals',
  Admin: 'Admin',
  PunchInOut: 'PunchInOut',
  Rewards: 'Rewards',
};
